const if_custom_functions_config = [
  {
    selector: '#managecomics-content style',
    urlMatch: '/pages/managecomics/foc',
    fn: managecomics_foc
  },
  {
    selector: '#managecomics-content #mc-tab-subscriptions',
    urlMatch: '/pages/managecomics/my_subscriptions',
    fn: managecomics_subscriptions
  },
  {
    selector: '#ProductThumbs.product-single__thumbnails.flickity-enabled.is-draggable',
    urlMatch: '/products/',
    fn: match_product_carousel_thumbnails_to_dropdown
  },
  {
    selector: '#managecomics-content div.mc-section div.mc-container div.mc-product-main h4.mc-product-title',
    urlMatch: '/pages/managecomics/products?id=',
    fn: manage_comics_zoom_covers
  },
  {
    selector: '#managecomics-content a.mc-subscribe-btn.main-subscribe',
    urlMatch: '/pages/managecomics',
    fn: manage_comics_login_return_to_page
  }
  // Add more configs as needed
];

(function() {
  const intervalMs = 200;
  const timeoutMs = 10000;
  let waited = 0;
  let config = if_custom_functions_config.slice();

  const interval = setInterval(function() {
    config = config.filter(function(cfg) {
      let urlOk = true;
      if (cfg.urlMatch) {
        if (typeof cfg.urlMatch === 'string') {
          urlOk = window.location.href.includes(cfg.urlMatch);
        } else if (cfg.urlMatch instanceof RegExp) {
          urlOk = cfg.urlMatch.test(window.location.href);
        }
      }
      if (!urlOk) return true;

      const el = document.querySelector(cfg.selector);
      if (el) {
        try {
          cfg.fn(el);
        } catch(e) {
          // Optionally log or handle error
        }
        return false;
      }
      return true;
    });

    if (config.length === 0) {
      clearInterval(interval);
    }

    waited += intervalMs;
    if (waited >= timeoutMs) {
      clearInterval(interval);
    }
  }, intervalMs);
})();


function managecomics_subscriptions() {
  console.log('Manage Comics subscriptions loaded');
  const $mc = document.querySelector('#managecomics-content');
  // Add more logic as needed
}


function managecomics_foc() {
  console.log('Manage Comics FOC loaded!');
  const $mc = document.querySelector('#managecomics-content');
  if ($mc) {
    mc_foc_center_pagination($mc);
    mc_foc_hijack_pagination2($mc);

    // Observe #mc-content for any changes
    const mcContent = document.querySelector('#mc-content');
    if (mcContent) {
      let observer = null; // must be accessible for disconnect/reconnect

      const observerCallback = (mutationsList) => {
        // Stop observing to avoid infinite loop
        observer.disconnect();

        console.log('#mc-content changed');

        // Your function that might trigger more mutations
        mc_foc_center_pagination($mc);

        // Start observing again
        observer.observe(mcContent, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
        });
      };

      observer = new MutationObserver(observerCallback);

      observer.observe(mcContent, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }
  }
}


function mc_foc_center_pagination($mc) {
  const pag = $mc.querySelector('.mc-pagination');
  if (pag && pag.parentElement) {
    pag.parentElement.classList.add('if-center-mc-pagination');
  }
}


// This version is slower since it reloads the whole page but is less convoluted
function mc_foc_hijack_pagination1($mc) {
  const links = $mc.querySelectorAll('.mc-pagination a:not(.active)');
  
  links.forEach(link => {
    const onclick = link.getAttribute('onclick');
    let url = null;
    if (onclick) {
      const match = onclick.match(/'([^']*)'/);
      url = match ? match[1] : null;
    }

    if (url) {
      url = removeQueryParam(url, 'o');
      link.removeAttribute('onclick');
      link.setAttribute('href', url);
    }
  });
}


// This version is slightly faster since it doesn't reload the whole page
let ogLoadPage;
function mc_foc_hijack_pagination2($mc) {
  if (!ogLoadPage) ogLoadPage = window.loadPage;

  window.loadPage = async function(url) {
    await newLoadPage(url);
    mc_foc_center_pagination($mc);
    history.pushState({}, '', removeQueryParam(url, 'o'));
    const section = document.querySelector('#managecomics-content .mc-section .mc-container');
    if (section) section.scrollIntoView({behavior:'instant', block:'start'});
  };
}


async function newLoadPage(url) {
  console.log('loadPage(', url, ')');
  
  try {
    const response = await fetch(fetchUrl, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({url: url})
    });

    if (response.status === 200) {
      const data = await response.json();
      updateContent(data);

      const anchor = document.getElementById('mc-top');
      if (anchor) {
        anchor.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
      return data;
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error('Error loading page:', error);
    throw error;
  }
}


function removeQueryParam(url, param) {
  const [base, query] = url.split('?');
  if (!query) return url;

  const params = new URLSearchParams(query);
  params.delete(param);

  const newQuery = params.toString();
  return newQuery ? `${base}?${newQuery}` : base;
}


let suppressThumbnailObserver = false;
function match_product_carousel_thumbnails_to_dropdown() {
  // Set up a MutationObserver to watch for class changes on thumbnails
  const carousel = document.querySelector(
    "#ProductThumbs.product-single__thumbnails.flickity-enabled.is-draggable div.flickity-viewport div.flickity-slider"
  );
  if (!carousel) return;

  function isSelectedThumb(el) {
    return (
      el.classList.contains("product-single__thumbnail") &&
      el.classList.contains("is-selected") &&
      el.classList.contains("is-nav-selected")
    );
  }

  function onMutation(mutationsList) {
    if (suppressThumbnailObserver) return; // GUARD: do nothing if suppressed
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const target = mutation.target;
        if (isSelectedThumb(target)) {
          suppressThumbnailObserver = true;
          selectVariantByMediaId(target.getAttribute("data-id"));
          // Allow UI update to finish, then re-enable observer
          setTimeout(() => { suppressThumbnailObserver = false; }, 200);
        }
      }
    }
  }

  const thumbs = carousel.querySelectorAll("div.product-single__thumbnail");
  thumbs.forEach((thumb) => {
    new MutationObserver(onMutation).observe(thumb, { attributes: true, attributeFilter: ["class"] });
  });

  thumbs.forEach((thumb) => {
    if (isSelectedThumb(thumb)) {
      selectVariantByMediaId(thumb.getAttribute("data-id"));
    }
  });
}

function selectVariantByMediaId(mediaId) {
  const map = window.productMediaVariantMap || [];
  const mapping = map.find(obj => obj.media_id === mediaId || obj.media_id == mediaId);
  if (!mapping) {
    console.log("No mapping found for media_id:", mediaId);
    return;
  }

  const optionValue = mapping.option_value;

  const currentValue = document.querySelector('div.product__selectors > div > div > popout-select > button > span').innerHTML;
  if (currentValue == optionValue) return;

  const popout = document.querySelector('div.product__selectors > div > div > popout-select');
  if (!popout) {
    console.log("Popout select not found");
    return;
  }

  selectPopoutOptionByValue(popout, optionValue);
}

function selectPopoutOptionByValue(popoutEl, value) {
  const option = popoutEl.querySelector(`[data-popout-option][data-value="${CSS.escape(value)}"]`);
  if (!option) {
    console.log("Option not found for value:", value);
    return;
  }

  // The theme expects a CustomEvent 'theme:popout:click'
  const event = new CustomEvent('theme:popout:click', {
    cancelable: true,
    bubbles: true,
    detail: { preventTrigger: false }
  });

  option.dispatchEvent(event);
}


function manage_comics_zoom_covers($mc) {
  if(is_mobile()) return;

  const selectors = [
    '#managecomics-content div.mc-section div.mc-product-main img',
    '#managecomics-content div.mc-section img.mc-product-img'
  ];
  const imgs = Array.from(document.querySelectorAll(selectors.join(',')));

  function isPlaceholder(img) {
    return img.src.endsWith('gf-image-placeholder.png');
  }

  // Set cursor and event listeners
  imgs.forEach(img => {
    if (isPlaceholder(img)) {
      img.style.cursor = 'not-allowed';
    } else {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', e => {
        e.stopPropagation();
        const title = getImageTitle(img);
        showImageModal(img.src, title);
      });
    }
  });

  function getImageTitle(img) {
    // First selector: .mc-product-main img
    if (img.closest('.mc-product-main')) {
      const parent = img.closest('.mc-product-main');
      const h4 = parent.querySelector('h4.mc-product-title');
      return h4 ? h4.innerText.trim() : '';
    }

    // Second selector: img.mc-product-img
    if (img.classList.contains('mc-product-img')) {
      const parentDiv = img.closest('div');
      const span = parentDiv ? parentDiv.querySelector('span') : null;
      if (span) {
        const html = span.innerHTML;
        const split = html.split(/<br\s*\/?>/i);
        // Get the text content up to the first <br>
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = split[0];
        return tempDiv.textContent.trim();
      }
    }
    return '';
  }

  function showImageModal(src, title) {
    const oldModal = document.getElementById('mc-image-modal');
    if (oldModal) oldModal.remove();

    const modal = document.createElement('div');
    modal.id = 'mc-image-modal';
    Object.assign(modal.style, {
      position: 'fixed',
      zIndex: 10000,
      top: 0, left: 0, right: 0, bottom: 0,
      width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'zoom-out',
      flexDirection: 'column'
    });

    const image = document.createElement('img');
    image.src = src;
    image.style.maxWidth = '95vw';
    image.style.maxHeight = '90vh';
    image.style.boxShadow = '0 0 24px #000';

    const titleText = document.createElement('div');
    titleText.textContent = title;
    titleText.style.color = '#fff';
    titleText.style.margin = '20px 0 0 0';
    titleText.style.fontSize = '1.3em';
    titleText.style.wordBreak = 'break-word';
    titleText.style.textAlign = 'center';
    titleText.style.textShadow = '0 2px 6px #000';

    modal.appendChild(image);
    modal.appendChild(titleText);

    modal.addEventListener('click', () => modal.remove());

    document.body.appendChild(modal);
  }
}


function manage_comics_login_return_to_page($mc) {
  const buttons = document.querySelectorAll('#managecomics-content a.mc-subscribe-btn.main-subscribe');
  const path = window.location.pathname + window.location.search + window.location.hash;
  buttons.forEach(btn => {
    if (!btn.innerText.toLowerCase().includes('please sign in')) return;
    btn.href = `/customer_authentication/login?return_to=${encodeURIComponent(path)}`;
  });
}


function is_mobile() {
  if (/Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|BlackBerry/i.test(navigator.userAgent)) {
    return true;
  }

  return false;
}